// extracted by mini-css-extract-plugin
export var completionBody = "_ky-2";
export var completionCard = "_ky-0";
export var completionFooter = "_ky-3";
export var completionTitle = "_ky-1";